import { AdminProject } from "../../project/models/Project";
import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminProjectApi = {
  page: async (pageSize: number, pageNumber: number) =>
    await jwtAuthAxios().get<Page<AdminProject>>(`/admin/projects`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  put: async (projectId: string, data: Partial<AdminProject>) =>
    await jwtAuthAxios().put<AdminProject>(
      `/admin/projects/${projectId}`,
      data
    ),
};
